export default "__VITE_ASSET__svs3XwPq__"